export default __webpack_public_path__ + "static/media/878e0c5a4613ce08e0781a0a8ff386a0.52bcd256.svg";